import { QiCardPendingContext } from "../types/qicard";

export const QICARD_PENDING_KEY = "qicard.pending";

export function saveQiCardPending(ctx: QiCardPendingContext): void {
  sessionStorage.setItem(QICARD_PENDING_KEY, JSON.stringify(ctx));
}

export function loadQiCardPending(): QiCardPendingContext | null {
  try {
    const raw = sessionStorage.getItem(QICARD_PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as QiCardPendingContext;
    if (!parsed?.transactionId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearQiCardPending(): void {
  sessionStorage.removeItem(QICARD_PENDING_KEY);
}

export function resolveTransactionIdFromUrl(
  searchParams: URLSearchParams
): string | null {
  const keys = [
    "transactionId",
    "transaction_id",
    "paymentId",
    "payment_id",
    "id",
  ];
  for (const key of keys) {
    const value = searchParams.get(key)?.trim();
    if (value) return value;
  }
  return null;
}
